import React from 'react';

const Disclaimer = (props) => {
    const { colors, microsite_clt } = props;
    console.log("colors", colors);
    // Get disclaimer content from props or use default
    const disclaimerText = 'Disclaimer: ' + microsite_clt?.custom_disclamer || '';

    // Don't render if no disclaimer content
    if (!disclaimerText) {
        return null;
    }

    return (
        <>
            <div className="px-8 max-sm:px-4 py-3 lg:max-w-7xl mx-auto" style={{ backgroundColor: colors?.primary || '#2167A7' }}>
                <p className='text-left text-white'>
                    {microsite_clt?.privacy_policy && microsite_clt?.privacy_policy !== '' && (
                        <a className='text-white underline' href={microsite_clt?.privacy_policy} target="_blank" rel="noreferrer">Privacy Policy*</a>
                    )}
                    {microsite_clt?.terms_and_condition && microsite_clt?.terms_and_condition !== '' && (
                    <>
                        {microsite_clt?.privacy_policy && microsite_clt?.privacy_policy !== '' && (
                        <span className='text-white mx-2'>|</span>
                        )}
                        <a className='text-white underline' href={microsite_clt?.terms_and_condition} target="_blank" rel="noreferrer">Terms & Conditions*</a>
                    </>
                    )}
                </p>
            </div>
            { microsite_clt?.custom_disclamer && (
                <div className="px-8 max-sm:px-4 py-3 lg:max-w-7xl mx-auto" style={{ backgroundColor: colors?.primary || '#2167A7', borderTop: `2px solid #ffffff` }}>
                    <div className="text-white">
                        <div 
                            className="text-sm max-sm:text-xs not-italic font-normal leading-6 opacity-90 text-left"
                            style={{ color: '#ffffff' }}
                            dangerouslySetInnerHTML={{ __html: disclaimerText }}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default Disclaimer;

